/* @flow */
import Button from 'components/Button.jsx';
import Glyph from 'components/Glyph.jsx';
import Group from 'entities/Group';
import Link from 'components/Link.jsx';
import React from 'react';
import TitleHeader from 'components/TitleHeader.jsx';
import EventTracking from 'lib/EventTracking';

function userText(users, role) {
  return users.length === 1 ? role : role + 's';
}

function AddedUsers(props) {
  const { users, role } = props;
  if (users.length) {
    return (
      <li className="TeacherAddUploadTab-success-listitem">
        <Glyph name="check" color="shamrock" />
        <strong>{users.length}</strong> {userText(users, role)} added to your school
      </li>
    );
  }
  return <noscript />;
}
AddedUsers.propTypes = { users: React.PropTypes.array, role: React.PropTypes.string };

function ExistingUsers(props) {
  const { users, role } = props;
  if (users.length) {
    return (
      <li className="TeacherAddUploadTab-success-listitem">
        <Glyph name="check" color="shamrock" />
        <strong>{users.length}</strong> {userText(users, role)} already in your school
      </li>
    );
  }
  return <noscript />;
}
ExistingUsers.propTypes = { users: React.PropTypes.array, role: React.PropTypes.string };

function ErrorUsers(props) {
  const { users, role, onClick } = props;
  if (users.length) {
    return (
      <li className="TeacherAddUploadTab-success-listitem">
        <Glyph name="close" color="lava" />
        <strong>{users.length}</strong> {userText(users, role)} not added.
        {' '}
        <Link onClick={onClick}>
          Fix errors.
        </Link>
      </li>
    );
  }
  return <noscript />;
}
ErrorUsers.propTypes = { users: React.PropTypes.array, onClick: React.PropTypes.func, role: React.PropTypes.string };

class TeacherAddUploadTabSuccess extends React.Component {
  static propTypes = {
    group: React.PropTypes.instanceOf(Group).isRequired,
    response: React.PropTypes.object.isRequired,
    onFixError: React.PropTypes.func.isRequired,
    role: React.PropTypes.string.isRequired,
  };

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
    eventScreenName: React.PropTypes.string,
  };

  handleClick = () => {
    const groupCode = this.props.group.getCode();
    this.context.router.push(`/classes/${groupCode}/people`);
  };

  render() {
    const { addedUsers, existingUsers, errorUsers } = this.props.response;
    EventTracking.view(this.context.eventScreenName, {
      num_added: addedUsers.length,
      num_already_in_org: existingUsers.length,
      num_not_added: errorUsers.length,
    });
    const dialogTitle = errorUsers.length ? 'Spreadsheet uploaded' : 'Upload successful';
    const CTAAction = errorUsers.length ? this.props.onFixError : this.handleClick;
    const CTAText = errorUsers.length ? 'Fix spreadsheet errors' : 'View added ' + this.props.role + 's';

    return (
      <div className="TeacherAddUploadTab-success">
        <div className="TeacherAddUploadTab-container">
          <TitleHeader
            image={require('assets/images/spreadsheet-success.svg')}
            imageClassName="TeacherAddUploadTab-titleHeader-image"
            title={dialogTitle}
          />
          <ul className="TeacherAddUploadTab-success-list">
            <AddedUsers users={addedUsers} role={this.props.role} />
            <ExistingUsers users={existingUsers} role={this.props.role} />
            <ErrorUsers
              users={errorUsers}
              role={this.props.role}
              onClick={this.props.onFixError}
            />
          </ul>
        </div>
        <Button
          onClick={CTAAction}
          className="TeacherAddUploadTab-success-button"
          eventElementName="TeacherAddUploadTab-success-button">
          {CTAText}
        </Button>
      </div>
    );
  }
}

export default TeacherAddUploadTabSuccess;



// WEBPACK FOOTER //
// ./src/groups/components/TeacherAddUploadTabSuccess.jsx